<template>
    <div class="bg-neutral-700 z-[1000] w-screen shadow-lg shadow-neutral-800 top-0 left-0 fixed pr-4">
        <div class="container mx-auto h-28 flex justify-between items-center">
            <Logo />

            <ul class="flex">
                <li class="font-bold text-lg text-neutral-50 ml-11 h-28 pt-10 relative"
                    :class="{
                        'border-b-neutral-50': selected === item.section,
                        'border-b-neutral-700': selected !== item.section,
                        'group': item.sub_menu.length > 0,
                    }"
                    v-for="item in menu"
                >
                    <Link :href="item.link"
                    >
                        {{ item.title }}
                    </Link>

                    <template v-if="item.sub_menu.length > 0">

                        <DropMenu :items="item.sub_menu"
                                  :section="item.title"
                                  :path="path"
                                  :home="item.link"
                        />
                    </template>

                </li>

                <li class="font-bold text-lg text-neutral-50 ml-11 h-28 pt-10 relative">
                    <a href="https://congress.fantastic.build" target="_blank" title="Congress">
                        <img class="congress-btn" src="/images/congress_btn.svg" alt="Congress">
                    </a>
                </li>
            </ul>
        </div>

    </div>

</template>

<script setup>
import {Link} from "@inertiajs/inertia-vue3";
import { Inertia } from '@inertiajs/inertia'
import Logo from "./Logo"
import DropMenu from "./DropMenu"

const props = defineProps({
        selected: String,
    });

const menu = [
    {title: 'Home', link: '/', section: 'Home', sub_menu:[]},
    {title: 'What is a Home Theater?', link: '/theater', section: 'Theater', sub_menu: [
            {title: 'Home Theater Vs. Media Room', link: '/theater/comparison'},
            {title: 'Good, Better, Best overview', link: '/theater/overview'},
            {title: 'Good in depth', link: '/theater/good'},
            {title: 'Better In depth', link: '/theater/better'},
            {title: 'Best in depth', link: '/theater/best'},
            {title: 'Top 5 Do’s and Don’t', link: '/theater/top'},
        ]},
    {title: 'About', link: '/about', section: 'About', sub_menu:[
            {title: 'FTI, Company & Strengths', link: '/about/company'},
            {title: 'FTI, Facility & Manufacturing', link: '/about/manufacturing'},
            {title: 'Our Process', link: '/about/process'},
            {title: 'Client Roadmap', link: '/about/roadmap'},
            {title: 'Customer & Partner Reviews', link: '/about/customer'},
        ]},
    {title: 'Services', link: '/services', section: 'Services', sub_menu:[
            {title: 'CA-PM', link: '/services/ca-pm'},
            {title: 'Construction', link: '/services/construction'},
            {title: 'Consulting', link: '/services/consulting'},
            {title: 'Design', link: '/services/design'},
            {title: 'Engineering', link: '/services/engineering'},
            {title: 'Specialty product & acoustics', link: '/services/specialty'},
        ]},
    {title: 'Portfolio', link: '/portfolio', section: 'Portfolio', sub_menu:[
            {title: 'Projects Gallery', link: '/portfolio/projects'},
            {title: 'Case Studies', link: '/portfolio/studies'},
            {title: 'FTI in media', link: '/portfolio/fti'},
            {title: 'Products Gallery', link: '/portfolio/products'},
        ]},
    {title: 'FAQ', link: '/faq', section: 'Faq', sub_menu:[
            {title: 'FAQ - GC', link: '/faq/gc'},
            {title: 'FAQ - Designer/Arc', link: '/faq/designers'},
            {title: 'FAQ - End User', link: '/faq/users'},
        ]},
    {title: 'Contact Details', link: '/contacts', section: 'Contacts', sub_menu:[
            {title: 'Contacts Form', link: '/contacts/form'},
        ]},
];

const path = window.location.pathname;

const logout = () => {
    Inertia.delete(route('logout'));
}

</script>

<style lang="scss" scoped>
    .congress-btn{

    }
</style>
